export type SatelliteData = { landUseType: string; greenAreaPercent: number; solarExposureHours: number };

export function fetchSatelliteData(lat: number, lon: number): SatelliteData {
  // Mock deterministic numbers from coords
  const seed = Math.abs(Math.sin(lat*lon));
  return {
    landUseType: seed>0.66? 'urban' : seed>0.33? 'suburban' : 'rural',
    greenAreaPercent: Math.round((0.2+seed*0.6)*100),
    solarExposureHours: Math.round(3 + seed*5)
  };
}



















